document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".header-row-first");
  const stickyClass = "sticky";
  const scrollThreshold = 135;
  
  let headerHeight = header.offsetHeight;

  const content = document.querySelector("main") || document.body;

  const handleScroll = () => {
    if (window.scrollY > scrollThreshold) {
      header.classList.add(stickyClass);
      content.style.marginTop = `${headerHeight}px`;
    } else {
      header.classList.remove(stickyClass);
      content.style.marginTop = 0;
    }
  };

  window.addEventListener("scroll", handleScroll);
});
